import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { getTranslation } from "../locales";
import "./RecordingIndicator.css";

export default function RecordingIndicator() {
  const { currentLanguage } = useLanguage();
  const t = getTranslation(currentLanguage);

  return (
    <div className="recording-indicator">
      <div className="circle red"></div>
      <span>{t.conference.recording}</span>
    </div>
  );
}
